import React, { createContext, useContext, type FC, type PropsWithChildren } from 'react';
import type { TimelineCustomComponents } from '@atlassian/jira-issue-table-timeline/src/common/types.tsx';
import { useIsTimelineEnabled } from '../features/selectors.tsx';

const TimelineCustomComponentsContext = createContext<TimelineCustomComponents | null>(null);

export type TimelineCustomComponentsProviderProps = PropsWithChildren<{
	components?: TimelineCustomComponents;
}>;

export const TimelineCustomComponentsProvider: FC<TimelineCustomComponentsProviderProps> = ({
	children,
	components,
}) => (
	<TimelineCustomComponentsContext.Provider value={components ?? null}>
		{children}
	</TimelineCustomComponentsContext.Provider>
);

export const useTimelineCustomComponents = () => {
	const context = useContext(TimelineCustomComponentsContext);
	const isTimelineEnabled = useIsTimelineEnabled();

	if (!isTimelineEnabled) {
		return null;
	}

	if (!context) {
		throw new Error(
			'useTimelineCustomComponents must be used within a TimelineCustomComponentsProvider',
		);
	}

	return context;
};
